import React, { Suspense, useCallback } from 'react'
import { Element } from 'react-scroll'
import MemoBrandsSection from './components/BrandsSection'

import { useTrackOriginClick } from 'helpers/tracking/hooks/trackOriginClick'
import { useBrandOverviewPageStore } from 'store/context'
import styled from 'styled-components'
import { outline } from 'uiComponents/constants/colors'

const Container = styled.div<{ $estimatedHeight: number }>`
  margin: 20px 0 0;
  content-visibility: auto;
  ${({ $estimatedHeight }) =>
    $estimatedHeight && `contain-intrinsic-size: 100vw ${$estimatedHeight}px;`}

  > div {
    border-top: 2px solid ${outline};
  }
`

const BrandsList: React.FC = () => {
  const brandsList = useBrandOverviewPageStore(store => store.brandsList)
  const trackOriginClick = useTrackOriginClick()
  const onBrandClick = useCallback(() => trackOriginClick('brands_list'), [])

  if (!brandsList.length) {
    return null
  }

  const brandsCount = brandsList.reduce(
    (sum, brandList) => sum + brandList.brands.length,
    0,
  )
  const brandRowHeight = 30.5
  const estimatedHeight = (brandRowHeight * brandsCount) / 2

  return (
    // eslint-disable-next-line no-restricted-syntax
    <Suspense>
      <Container $estimatedHeight={estimatedHeight}>
        {brandsList.map(brandSection => (
          <Element key={brandSection.id} name={`Letter${brandSection.id}`}>
            <MemoBrandsSection
              brandsGroup={brandSection}
              onBrandClick={onBrandClick}
            />
          </Element>
        ))}
      </Container>
    </Suspense>
  )
}

export default BrandsList
